/* eslint-disable no-console */
const filterToggle = () => {
  // Elements
  const filterMenus = document.querySelectorAll('.filter-heading');

  if (filterMenus) {
    [].map.call(filterMenus, btn => btn.addEventListener('click', (event) => {
      event.preventDefault();
      // Toggle class of .is-active on .filter-set
      btn.parentElement.classList.toggle('is-active');
      const isExpanded = btn.parentElement.classList.contains('is-active');
      btn.setAttribute('aria-expanded', isExpanded);
    }));
  }
};

export default filterToggle;
/* eslint-enable no-console */
